import React, { Component } from 'react';
import Customer from './customer.jsx';

export default class CustomersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      isLoading: !props.customers,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
      data: {
        name: 'All Customers'
      },
      customers: props.customers || null,
      url: props.url || '/api/v1/portal/customers/all/for-current-user/with-uninvoiced-jobs',
      viewJustOneCustomer: props.viewJustOneCustomer || false,
    };
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getCustomersDataWithUninvoicedJobs();
    }
    let that = this;
    Echo.channel('customers-table')
      .listen('CustomersTableChanged', (e) => {
        that.getCustomersDataWithUninvoicedJobs();
      });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      customers: nextProps.customers
    });
  }
  getCustomersDataWithUninvoicedJobs() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          customers: response,
          isLoading: false
        })
      });
    });
  }
  render() {
    let Customers = [];
    let totalJobsAwaitingInvoice = 0;
    if ((this.state.customers !== null) &&
      this.state.customers.length > 0) {
      this.state.customers.forEach(
        function(i) {
          if (i.jobs) {
            totalJobsAwaitingInvoice = totalJobsAwaitingInvoice +
              i.jobs.length;
          }
          Customers.push(
            <Customer key={'customer-'+i.id} data={i} />
            );
      });
    }
    return (
      <div>
        {
        (this.state.isLoading) ?
        (<span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i></span>) :
        (<div className="customers-table">
          <div className="customers-table-header-row row">
            <div className="col-md-3">
                Customer
            </div>
            <div className="col-md-3">
                Jobs Awaiting Invoice <div
                className={"customer-jobs-awaiting-invoice-count"+(
                  (totalJobsAwaitingInvoice > 0) ? ' red ' : ' green '
                )}
                onClick={(e) => {
                  let elems = document.getElementsByClassName(
                    'no-jobs-awaiting-invoice'
                  );
                  if (elems.length > 0) {
                    for (let item of elems) {
                      item.classList.toggle('toggle-hide');
                    }
                  }
                }}
                title="Hide/Show Customers with no jobs awaiting invoice."
                >
                {totalJobsAwaitingInvoice}
                </div>
            </div>
            <div className="col-md-2">
              Invoiced Jobs
            </div>
            <div className="col-md-2">
              Settings and Info
            </div>
            <div className="col-md-2">
               Jobs
            </div>
          </div>
              {Customers}
        </div>
        )
      }
    </div>
    );
  }
}
